import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { ModalWrapper } from './styled';

const ModalCommon = (props) => {
  useEffect(() => {
    if (props.open) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [props.open]);
  const {
    children,
    title,
    open,
    onCancel,
    width,
    height,
    heightHeader,
    footer,
    onAfterOpen,
    padding,
    rootClassName,
    forceRender,
  } = props;
  return (
    <ModalWrapper
      height={height}
      heightHeader={heightHeader}
      title={title ?? ''}
      open={Boolean(open)}
      width={width ?? '600px'}
      onCancel={onCancel}
      footer={footer}
      centered
      maskClosable={false}
      keyboard={false}
      afterOpenChange={(opened) => {
        if (opened && onAfterOpen) {
          onAfterOpen();
        } else if (!opened) {
          try {
            const selector = rootClassName
              ? `.${rootClassName} .ant-modal-body`
              : '.ant-modal-body';
            const modalBody = document.querySelector(selector);
            if (modalBody) {
              modalBody.scrollTop = 0;
            }
          } catch (_) {
            // noop
          }
        }
      }}
      rootClassName={rootClassName}
      forceRender={forceRender}
      padding={padding}
    >
      {children}
    </ModalWrapper>
  );
};

ModalCommon.propTypes = {
  title: PropTypes.node,
  open: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSubmit: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.oneOf([null, undefined]),
  ]),
  onCancel: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.oneOf([null, undefined]),
  ]),
  padding: PropTypes.arrayOf(PropTypes.number),
  rootClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([null, undefined]),
  ]),
  forceRender: PropTypes.bool,
};

export default ModalCommon;
